import {
  getAudPreferencesService,
  languagePreferecesService,
} from '../../../api/services/user/audSubPreferences';
import getEncode from './getEncode';

export const fetchUserLanguagePreferences = async ({ userToken }) => {
  try {
    const { data: defaultLanguageResp } = await languagePreferecesService({
      userToken,
    });
    const mock = {
      data: {
        live: {
          audio: 'ES',
          subtitle: null,
        },
        vod: {
          audio: 'ES',
          subtitle: null,
        },
      },
    };

    sessionStorage.setItem(
      'userLanguagePreferences',
      JSON.stringify({
        vodLanguageConfig: {
          preferred_audio: defaultLanguageResp?.data.vod.audio,
          preferred_subtitle: defaultLanguageResp?.data.vod.subtitle,
        },
        liveLanguageConfig: {
          preferred_audio: defaultLanguageResp?.data.live.audio,
          preferred_subtitle: defaultLanguageResp?.data.live.subtitle,
        },
      }),
    );
  } catch (error) {
    sessionStorage.setItem(
      'userLanguagePreferences',
      JSON.stringify({
        vodLanguageConfig: {
          preferred_audio: null,
          preferred_subtitle: null,
        },
        liveLanguageConfig: {
          preferred_audio: null,
          preferred_subtitle: null,
        },
      }),
    );
    console.log(error, 'USER LANGUAGE PREFERENCES');
  }
};

export const getDubSubLanguageParams = (
  preferred_audio,
  preferred_subtitle,
) => {
  const languageParams = {};
  if (preferred_audio && preferred_subtitle) {
    languageParams['preferred_audio'] = preferred_audio;
    languageParams['preferred_subtitle'] = preferred_subtitle;
  } else if (preferred_audio) {
    languageParams['preferred_audio'] = preferred_audio;
  }

  return languageParams;
};

export const getLanguageParamsByContentType = ({ defaultLanguage, isLive }) => {
  const userLanguageConfig = JSON.parse(
    sessionStorage.getItem('userLanguagePreferences'),
  );
  const { vodLanguageConfig } = userLanguageConfig || {};

  if (isLive) {
    // return getDubSubLanguageParams(
    //   liveLanguageConfig?.preferred_audio,
    //   liveLanguageConfig?.preferred_subtitle,
    // );
    return {};
  }

  if (defaultLanguage) {
    return getDubSubLanguageParams(
      defaultLanguage?.audio,
      defaultLanguage?.subtitle,
    );
  } else if (!defaultLanguage && vodLanguageConfig?.preferred_audio !== null) {
    return getDubSubLanguageParams(
      vodLanguageConfig?.preferred_audio,
      vodLanguageConfig?.preferred_subtitle,
    );
  }

  return {};
};

export const getTickLanguageParams = ({ isLive, currentAudioLanguage }) => {
  if (isLive) {
    return {
      // audio: liveConfig.preferred_audio,
      // subtitles: liveConfig.preferred_subtitle,
    };
  }

  return {
    audio: currentAudioLanguage?.audio,
    subtitles: currentAudioLanguage?.subtitle,
  };
};

export const findDefaultLanguage = ({
  defaultAudio,
  defaultSubtitle,
  availableLanguages,
}) => {
  if (defaultAudio && defaultSubtitle) {
    return availableLanguages.find(
      language =>
        language.audio === defaultAudio &&
        language.subtitle === defaultSubtitle,
    );
  }
  return availableLanguages.find(language => language.audio === defaultAudio);
};

export const getLanguageByContent = async ({ groupId, availableLanguages }) => {
  try {
    const {
      data: { response },
    } = await getAudPreferencesService({
      group_id: groupId,
    });

    if (!response[0]?.Preferrences || Array.isArray(response[0].Preferrences)) {
      const languageSaved = sessionStorage.getItem(
        'default_audio_option_selected',
      );
      if (languageSaved && availableLanguages) {
        const languageFinded = availableLanguages?.find(
          lang => lang.option_id === languageSaved,
        );
        return {
          audio: languageFinded?.audio,
          subtitle: languageFinded?.subtitle,
        };
      }

      return null;
    }

    return {
      audio: response[0]?.Preferrences?.Audio,
      subtitle: response[0]?.Preferrences?.Subtitle,
    };
  } catch (error) {
    console.log(error);
    return null
  }
};

const getUserLanguages = (isLive) => {
  const userLanguageConfig = JSON.parse(
    sessionStorage.getItem('userLanguagePreferences'),
  );

  if (userLanguageConfig) {
    if (isLive) {
      // AUDIO-LIVE
      // return {
      //   audio: userLanguageConfig.liveLanguageConfig.preferred_audio,
      //   subtitle: userLanguageConfig.liveLanguageConfig.preferred_subtitle,
      // };
    } else {
      return {
        audio: userLanguageConfig.vodLanguageConfig.preferred_audio,
        subtitle: userLanguageConfig.vodLanguageConfig.preferred_subtitle,
      };
    }
  } else {
    return null
  }
}

export const getLanguageEncode = async ({
  isLive,
  availableLanguages,
  contentData,
  user,
  groupId,
}) => {
  if (isLive || !user.userhash) {
    // AUDIO-LIVE
    // return {
    //   ...getEncode(contentData.data, null, isLive),
    //   getMediaLanguageParams: {},
    // };
  }

  //Lenguaje configurado por contenido
  const languageConfigured = await getLanguageByContent({
    groupId,
    availableLanguages,
  }) || getUserLanguages(isLive);

  const defaultLanguage = languageConfigured
    ? findDefaultLanguage({
        defaultAudio: languageConfigured?.audio,
        defaultSubtitle: languageConfigured?.subtitle,
        availableLanguages: availableLanguages,
      })
    : null;

  return {
    ...getEncode(contentData.data, defaultLanguage?.option_id || null, isLive),
    getMediaLanguageParams: getLanguageParamsByContentType({
      defaultLanguage,
      isLive,
    }),
  };
};
